module.exports = __webpack_public_path__ + "static/Truck1-ba32cace657aa76a3951811212c3d333.png";